<template src="@/templates/socialMedia.html"></template>

<script>
export default {
  name: "socialMedia"
}
</script>

<style scoped>
myIcon-group >>> .fa-facebook-f:before {
  border: 3px solid #ffffff;
}
</style>
